import modal from './modal.html'

let controller = function(
	$ionicHistory,
	$ionicLoading,
	$ionicModal,
	$ionicScrollDelegate,
	$q,
	$scope,
	$state,
	_,
	Category,
	Favorite,
	Filter,
	growl,
	User,
	user,
) {
	"ngInject"

	var vm = this;

	vm.selectedGroup = 1;

	vm.categoriesPages = 0;
	vm.categoriesPage = 0;
	vm.categoriesOffset = 0;

	vm.viewsPages = 0;
	vm.viewsPage = 0;
	vm.viewsOffset = 0;

	vm.favoritesPages = 0;
	vm.favoritesPage = 0;
	vm.favoritesOffset = 0;

	$scope.modal = $ionicModal.fromTemplate(modal, {
		scope: $scope,
		animation: 'slide-in-up'
	});

	function initialize() {

		var date = new Date();
		var hours = date.getHours();

		if (hours >= 0 && hours < 6) {
			vm.greeting = 'goodnight';
		} else if (hours >= 6 && hours < 12) {
			vm.greeting = 'goodmorning';
		} else if (hours >= 12 && hours < 18) {
			vm.greeting = 'goodafternoon';
		} else {
			vm.greeting = 'goodevening';
		}

		$q.all([
			Favorite.get(),
			User.views(),
			Category.all(),
			User.categories()
		]).then(res => {
			vm.favorites = res[0];
			vm.views = res[1];
			vm.groups = res[2];
			vm.categories = res[3];
			vm.list = vm.categories.map(category => category.id);
			vm.allCategories = _.flatten(vm.groups.map(group => group.categories));
			vm.categoriesPages = Math.ceil(vm.categories.length / 4);
			vm.viewsPages = Math.ceil(vm.views.length / 4);
			vm.favoritesPages = Math.ceil(vm.favorites.length / 4);
		}).finally(() => {
			$ionicLoading.hide();
		});

	}

	vm.toSearch = function(id) {
		Filter.setAllActives({
			categories: [id]
		});
		$ionicHistory.nextViewOptions({
			historyRoot: true,
			disableBack: true
		});
		$state.go('tab.search');
	}

	vm.toProduct = function(id) {
		$ionicHistory.nextViewOptions({
			disableBack: true
		});
		$state.go('tab.product', {
			ref: 'home',
			uid: id
		});
	}

	vm.clearFavorites = function() {
		$ionicLoading.show();
		Favorite.clear().then(function() {
			return Favorite.get();
		}).then(function(res) {
			vm.favorites = res;
			vm.favoritesPages = Math.ceil(vm.favorites.length / 4);
			vm.favoritesPage = 0;
			vm.favoritesOffset = 0;
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	vm.clearViews = function() {
		$ionicLoading.show();
		User.clearViews().then(function() {
			return User.views();
		}).then(function(res) {
			vm.views = res;
			vm.viewsPages = Math.ceil(vm.categories.length / 4);
			vm.viewsPage = 0;
			vm.viewsOffset = 0;
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	vm.toggle = function(id) {
		if (vm.list.indexOf(id) > -1) {
			vm.list.splice(vm.list.indexOf(id), 1);
		} else {
			vm.list.push(id);
		}
	}

	vm.cancelCategories = function() {
		$scope.modal.hide();
	}

	vm.storeCategories = function() {
		$ionicLoading.show();
		$scope.modal.hide();
		User.storeCategories(vm.list).then(function(res) {
			vm.categories = res;
			vm.list = vm.categories.map(category => category.id);
			vm.categoriesPages = Math.ceil(vm.categories.length / 4);
			vm.categoriesPage = 0;
			vm.categoriesOffset = 0;
		});
		$ionicLoading.hide();
	}

	vm.changeCategories = function() {
		vm.categoryQuery = '';
		$scope.modal.show();
	}

	vm.swipeCategories = function(direction) {
		if (direction) {
			if (vm.categoriesPage > 0) {
				vm.categoriesPage--;
			}
		} else {
			if (vm.categoriesPage < Math.ceil(vm.categories.length / 4)-1) {
				vm.categoriesPage++;
			}
		}
		if (vm.categoriesPage === Math.ceil(vm.categories.length / 4)-1) {
			if (vm.categoriesPage * 4 > vm.categories.length - 4) {
				vm.categoriesOffset = vm.categories.length - 4;
			} else {
				vm.categoriesOffset = (vm.categoriesPage * 4);
			}
		} else {
			vm.categoriesOffset = (vm.categoriesPage * 4);
		}
	}

	vm.swipeViews = function(direction) {
		if (direction) {
			if (vm.viewsPage > 0) {
				vm.viewsPage--;
			}
		} else {
			if (vm.viewsPage < Math.ceil(vm.views.length / 4)-1) {
				vm.viewsPage++;
			}
		}
		if (vm.viewsPage === Math.ceil(vm.views.length / 4)-1) {
			if (vm.viewsPage * 4 > vm.views.length - 4) {
				vm.viewsOffset = vm.views.length - 4;
			} else {
				vm.viewsOffset = (vm.viewsPage * 4);
			}
		} else {
			vm.viewsOffset = (vm.viewsPage * 4);
		}
	}

	vm.switchSelectedGroup = function(id) {
		vm.selectedGroup = id;
		$ionicScrollDelegate.$getByHandle('categories').scrollTop();
	}

	vm.swipeFavorites = function(direction) {
		if (direction) {
			if (vm.favoritesPage > 0) {
				vm.favoritesPage--;
			}
		} else {
			if (vm.favoritesPage < Math.ceil(vm.favorites.length / 4)-1) {
				vm.favoritesPage++;
			}
		}
		if (vm.favoritesPage === Math.ceil(vm.favorites.length / 4)-1) {
			if (vm.favoritesPage * 4 > vm.favorites.length - 4) {
				vm.favoritesOffset = vm.favorites.length - 4;
			} else {
				vm.favoritesOffset = (vm.favoritesPage * 4);
			}
		} else {
			vm.favoritesOffset = (vm.favoritesPage * 4);
		}
	}

	$scope.$on('$ionicView.loaded', e => {
		$ionicLoading.show();
	});

	$scope.$on('$ionicView.enter', function(e) {
		initialize();
	});
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/home/home.controller.js